module.exports = "file-text"